var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.666 13v-1.333c0-1.243-.85-2.287-2-2.583m-2.333-7.89a2.668 2.668 0 0 1 0 4.945m1 6.861c0-1.242 0-1.864-.203-2.354a2.667 2.667 0 0 0-1.443-1.443C9.197 9 8.576 9 7.333 9h-2c-1.243 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443-.203.49-.203 1.111-.203 2.354M9 3.667a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Z"
  })));
};
export default SvgPeople;